(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brk-prova-social"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brk-social-proof')) {
    customElements.define('brk-social-proof', class extends HTMLElement {
      // Custom element: reinicia sozinho quando o editor re-renderiza a seção
      connectedCallback() {
        const track = this.querySelector('.brk-social__track');
        const videos = [...this.querySelectorAll('.brk-social__video')];
        if (!track || !videos.length) return;
        const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.videos = videos;
        const visibleVideos = new Set();
        const loadVideo = (video) => {
          const source = video.querySelector('source[data-src]');
          if (!source) return;
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.load();
        };
        const playVideo = (video) => {
          if (document.hidden) return;
          loadVideo(video);
          video.play().catch(() => {});
        };

        this.playIo = new IntersectionObserver((entries) => {
          entries.forEach(({ target: video, isIntersecting, intersectionRatio }) => {
            if (!isIntersecting || intersectionRatio < 0.25) {
              visibleVideos.delete(video);
              video.pause();
              return;
            }
            visibleVideos.add(video);
            if (video.dataset.poster) {
              video.poster = video.dataset.poster;
              video.removeAttribute('data-poster');
            }
            if (!reduceMotion) playVideo(video);
          });
        }, { rootMargin: '0px', threshold: [0, 0.25] });
        videos.forEach((video) => this.playIo.observe(video));

        this.visibilityHandler = () => {
          if (document.hidden) videos.forEach((video) => video.pause());
          else if (!reduceMotion) visibleVideos.forEach(playVideo);
        };
        document.addEventListener('visibilitychange', this.visibilityHandler);

        if (reduceMotion) {
          track.classList.add('is-manual');
          videos.forEach((v) => v.parentElement.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            v.paused ? playVideo(v) : v.pause();
          }));
        }

        // Desktop: começa centralizado (cards cortados nas duas pontas)
        if (matchMedia('(min-width: 768px)').matches) {
          track.scrollLeft = (track.scrollWidth - track.clientWidth) / 2;
        }

        // Arrastar com o mouse; o ponteiro só é capturado depois que vira arraste
        let startX = 0, startScroll = 0, down = false, moved = false;
        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;
          down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        });
        track.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 4) {
            moved = true;
            track.classList.add('is-dragging');
            track.setPointerCapture(e.pointerId);
          }
          if (moved) track.scrollLeft = startScroll - dx;
        });
        const end = () => {
          if (!down) return;
          down = false;
          if (moved) {
            const left = track.scrollLeft;
            track.classList.remove('is-dragging');
            track.scrollLeft = left;
          }
        };
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        // Clique no card de produto não conta se foi um arraste
        track.addEventListener('click', (e) => {
          if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
        }, true);
      }

      disconnectedCallback() {
        this.playIo?.disconnect();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.videos?.forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  document.querySelectorAll('#topbar .topbar-copy-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var coupon = btn.getAttribute('data-coupon');
      if (!coupon) return;

      navigator.clipboard.writeText(coupon).then(function() {
        btn.classList.add('is-copied');

        var msg = document.createElement('span');
        msg.className = 'topbar-copied-msg';
        msg.innerHTML = '<svg viewBox="0 0 16 16"><polyline points="3.5 8.5 6.5 11.5 12.5 4.5"></polyline></svg> COPIADO!';
        btn.insertAdjacentElement('afterend', msg);

        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            msg.classList.add('is-visible');
          });
        });

        setTimeout(function() {
          msg.classList.remove('is-visible');
          btn.classList.remove('is-copied');
          setTimeout(function() { msg.remove(); }, 300);
        }, 2500);
      });
    });
  });

  if (!customElements.get('topbar-shipping-timer')) {
    class TopbarShippingTimer extends HTMLElement {
      connectedCallback() {
        this.countdownEl = this.querySelector('.topbar-shipping__countdown');
        this.timerRow = this.querySelector('.topbar-shipping__timer-row');
        this.windows = this.parseWindows(this.dataset.windows);
        this.expiredMessage = (this.dataset.expiredMessage || '').trim();
        this.switchSlider = this.dataset.switchSlider === 'true';

        // Sem nenhuma janela com data de fim: some o contador, o "Texto do timer" fica.
        if (!this.windows.length) {
          this.hidden = true;
          this.setSliderVisible(false);
          return;
        }

        this.update = this.update.bind(this);
        this.update();
        this.interval = setInterval(this.update, 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      // Lista de janelas [{s, e}] já fixadas no fuso da loja, ordenadas por término.
      parseWindows(raw) {
        var list;
        try {
          list = JSON.parse(raw || '[]');
        } catch (e) {
          list = [];
        }
        if (!Array.isArray(list)) return [];

        return list
          .map(function (w) {
            var end = w && w.e ? new Date(w.e) : null;
            if (!end || isNaN(end.getTime())) return null;
            var start = w.s ? new Date(w.s) : null;
            if (start && isNaN(start.getTime())) start = null;
            return { start: start ? start.getTime() : null, end: end.getTime() };
          })
          .filter(Boolean)
          .sort(function (a, b) { return a.end - b.end; });
      }

      // Janela em andamento agora ou, se não houver, a próxima agendada.
      currentWindow(now) {
        for (var i = 0; i < this.windows.length; i++) {
          if (now < this.windows[i].end) return this.windows[i];
        }
        return null;
      }

      // Mostra/esconde o bloco "Slider de texto" quando a troca está ativada.
      setSliderVisible(visible) {
        if (!this.switchSlider) return;
        var root = this.closest('#topbar') || document;
        root.querySelectorAll('[data-topbar-slider]').forEach(function (el) {
          el.classList.toggle('is-switch-hidden', !visible);
        });
      }

      // Timer + bloco "Texto do timer" aparecem e somem juntos.
      setVisible(visible) {
        this.hidden = !visible;
        var root = this.closest('#topbar') || document;
        root.querySelectorAll('[data-topbar-timer-part]').forEach(function (el) {
          el.hidden = !visible;
        });
      }

      update() {
        var now = Date.now();
        var win = this.currentWindow(now);

        // Todas as janelas terminaram.
        if (!win) {
          if (this.interval) clearInterval(this.interval);

          // Troca pelo slider: esconde este bloco e revela o slider de texto.
          if (this.switchSlider) {
            this.setVisible(false);
            this.setSliderVisible(true);
            return;
          }

          if (this.expiredMessage) {
            this.setVisible(true);
            if (this.timerRow) {
              this.timerRow.innerHTML =
                '<span class="topbar-shipping__expired"></span>';
              this.timerRow.firstChild.textContent = this.expiredMessage;
            }
          } else {
            this.setVisible(false);
          }
          return;
        }

        // Próxima janela ainda não começou -> barra oculta até a hora marcada.
        if (win.start && now < win.start) {
          this.setVisible(false);
          this.setSliderVisible(true);
          return;
        }

        var diff = win.end - now;

        this.setVisible(true);
        this.setSliderVisible(false);

        var pad = function (n) { return String(n).padStart(2, '0'); };
        var ONE_DAY = 86400000;
        var HOURS_THRESHOLD = 2 * ONE_DAY; // abaixo de 48h mostra horas:minutos:segundos

        if (!this.countdownEl) return;

        var segs, caps;
        if (diff >= HOURS_THRESHOLD) {
          // 48h ou mais restando: dias:horas:minutos
          segs = [
            Math.floor(diff / ONE_DAY),
            Math.floor((diff / 3600000) % 24),
            Math.floor((diff / 60000) % 60)
          ];
          caps = [segs[0] === 1 ? 'Dia' : 'Dias', 'Horas', 'Minutos'];
        } else {
          segs = [
            Math.floor(diff / 3600000),
            Math.floor((diff / 60000) % 60),
            Math.floor((diff / 1000) % 60)
          ];
          caps = ['Horas', 'Minutos', 'Segundos'];
        }

        this.countdownEl.innerHTML = segs
          .map(function (v, i) {
            return (
              '<span class="topbar-shipping__unit">' +
              '<span class="topbar-shipping__num">' + pad(v) + '</span>' +
              '<span class="topbar-shipping__cap">' + caps[i] + '</span>' +
              '</span>'
            );
          })
          .join('<span class="topbar-shipping__sep"><span>:</span></span>');
      }
    }
    customElements.define('topbar-shipping-timer', TopbarShippingTimer);
  }

  } catch(e) { console.error(e); }
})();
})();
